import { z } from 'zod';

export const generateConclusionEvaluationSessionSchema = z.object({
  evaluation_session_id: z.uuid(),
});

export type GenerateConclusionEvaluationSessionPayload = z.infer<typeof generateConclusionEvaluationSessionSchema>;

export interface GenerateConclusionEvaluationSessionResponse {
  conclusion: string;
}
